import type { Resource } from '../../';
export const language_fr: Resource = {"default":"French"};
